module.exports = __webpack_public_path__ + "static/media/wrs3.png.17f6b001.jpg";